import axios from '@/axios-instance'

export const ModuleMaterialBank = {
  namespaced: true,

  state: {
    pages: [],
    currentPage: null,
    loading: false,
    error: false,
  },

  getters: {
    indexPage: (state) => state.pages.find((p) => p.act_as_index_page) || null,
  },

  mutations: {
    setPages(state, data) {
      state.pages = data
    },
    setCurrentPage(state, data) {
      state.currentPage = data
    },
    setLoading(state, value) {
      state.loading = value
    },
    setError(state, value) {
      state.error = value
    },
  },

  actions: {
    fetchPages(context) {
      context.commit('setLoading', true)
      return axios.get('/api/v1/material-bank/pages/')
        .then((res) => {
          context.commit('setPages', res.data)
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          context.commit('setLoading', false)
        })
    },

    fetchPage(context, path) {
      context.commit('setError', false)
      context.commit('setLoading', true)
      return axios.get(`/api/v1/material-bank/pages/${path}/`)
        .then((res) => {
          context.commit('setCurrentPage', res.data)
        })
        .catch((err) => {
          console.log(err)
          context.commit('setError', true)
        })
        .finally(() => {
          context.commit('setLoading', false)
        })
    },
  },
}
